import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap/lib';
import { CarouselTag } from 'site-modules/shared/components/carousel-tag/carousel-tag';
import './carousel-tag-list.scss';

const DEFAULT_TAG = 'DEFAULT';
export function CarouselTagList({ tagList = [], onTagSelect = null, currentTag = null, onClose = null }) {
  if (!tagList.length) return null;
  return (
    <div className="carousel-tag-list">
      <CarouselTag tag="See All" seeAll onClick={onTagSelect} isActive={currentTag === DEFAULT_TAG} />
      {tagList.map(tag => (
        <CarouselTag key={tag} tag={tag} onClick={onTagSelect} isActive={currentTag === tag} />
      ))}
      {onClose && (
        <Button className="px-0 py-0 close-tags-button text-white small hidden-md-up" onClick={onClose}>
          <span className="icon-cross2" aria-hidden />
        </Button>
      )}
    </div>
  );
}

CarouselTagList.propTypes = {
  currentTag: PropTypes.string,
  tagList: PropTypes.arrayOf(PropTypes.string),
  onTagSelect: PropTypes.func,
  onClose: PropTypes.func,
};
